import generateActions from 'utils/actions';

export const LOAD_OVERVIEW = generateActions('mailbox/LOAD_OVERVIEW');
export const LOAD_COUNTRIES = generateActions('mailbox/LOAD_COUNTRIES');
export const LOAD_STATISTICS = generateActions('mailbox/LOAD_STATISTICS');
export const LOAD_PLAYS = generateActions('mailbox/LOAD_PLAYS');
export const LOAD_DEVICES = generateActions('mailbox/LOAD_DEVICES');

export function loadOverview() {
  return {
    types: LOAD_OVERVIEW,
    promise: {
      url: '/statistics/overview',
    },
  };
}

export function loadCountries(filters = {}) {
  return {
    types: LOAD_COUNTRIES,
    promise: {
      url: '/statistics/countries',
      data: {
        from: filters.from,
        to: filters.to,
      },
    },
  };
}

export function loadStatistics(filters = {}) {
  return {
    types: LOAD_STATISTICS,
    promise: {
      url: '/statistics',
      data: {
        from: filters.from,
        to: filters.to,
      },
    },
  };
}

export function loadPlays(filters = {}) {
  return {
    types: LOAD_PLAYS,
    promise: {
      url: '/statistics/plays',
      data: filters,
    },
  };
}

export function loadDevices(filters = {}) {
  return {
    types: LOAD_DEVICES,
    promise: {
      url: '/statistics/devices',
      data: filters,
    },
  };
}
